export default "__VITE_ASSET__C77QR7f___"